module.exports = __webpack_public_path__ + "static/media/icons8-discord.2c2504db.svg";